import {isEmpty} from "../components/helpers/helpers";
import {getCurrentTime} from "../components/helpers/dates";

export function checkLocalStorageExpiration() {
    const storageKeys = ['north_cities', 'districts', 'property_types', 'cities_lists', 'property_deal_types', 'default_city'];
    const time = getCurrentTime();

    if (process.browser) {
        for (let storage of storageKeys) {
            let storageData = localStorage.getItem(storage);
            if (!isEmpty(storageData)) {
                storageData = JSON.parse(storageData);

                if (isEmpty(storageData.expire)) {
                    localStorage.removeItem(storage);
                } else if (time > storageData.expire) {
                    localStorage.removeItem(storage);
                }
            }
        }
    }
}